import React from 'react'

import { styled } from '@mui/material'
import { GridColumnGroupHeaderParams } from '@mui/x-data-grid-premium'


export type CustomHeaderProps = GridColumnGroupHeaderParams & {
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  className?: string
}

export const CustomHeader: React.FC<CustomHeaderProps> = ({
  startIcon,
  endIcon,
  className,
  ...props
}) => {
  return (
    <HeaderRoot className={className}>
      {startIcon}
      <HeaderText>{props.headerName ?? props.groupId}</HeaderText>
      {endIcon}
    </HeaderRoot>
  )
}

const HeaderRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  padding: theme.spacing(0, 0.5),
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
}))

const HeaderText = styled('span')`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
`
